<template>
<div class="chapter">
<div class="inner_page">
<p class="block_5">
<span class="text_3">
</span></p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2"><span class="text_">Dedication</span></h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_3"> </p>
<p class="block_4"><span class="text_1">This novel is dedicated to every child who has been neglected, discarded, traumatised, or assaulted by the grown-ups in their world. I hope this story reminds them that they are not alone. They can be strong, and even on their worst days—when the sun is too bright, and the night is too dark—they are capable of great things. Always fight for your happiness, and never again your pain.</span></p>
<p class="block_6"><span class="text_3"><br class="calibre1" id="calibre_pb_1"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?2afc9faa